import { ReactNode, useCallback } from 'react';
import Button from '../button/Button';
import Text from '../text/Text';
import styles from './ActionButton.module.css';
import { useAppContext } from 'src/app/state';
import { ActionType } from 'src/app/state/action-type.enum';

type ActionButtonProps = {
  MainButton: (props: {
    onClick: () => void;
    type: 'white' | 'black';
  }) => React.JSX.Element;
  onConfirm?: () => void;
  popUpHeader: string;
  popUpText: ReactNode;
  hasFooter?: boolean;
  skipButtonText?: string;
  confirmButtonText?: string;
  closeButtonType?: 'white' | 'black';
};

const ActionButton = ({
  onConfirm,
  MainButton,
  popUpHeader,
  popUpText,
  skipButtonText,
  confirmButtonText,
  closeButtonType = 'black',
  hasFooter = true,
}: ActionButtonProps) => {
  const { dispatch } = useAppContext();
  const handlePopUpClose = useCallback(
    () => dispatch({ type: ActionType.POP_UP_CLOSE, payload: {} }),
    [dispatch]
  );
  const handleConfirm = useCallback(() => {
    handlePopUpClose();
    onConfirm && onConfirm();
  }, [handlePopUpClose, onConfirm]);
  const handlePopUpOpen = useCallback(() => {
    const PopUpContent = () => (
      <>
        {popUpText}
        {hasFooter && (
          <div className={styles.footer}>
            <div className={`${styles.button} ${styles['left-button']}`}>
              <Button
                type='white'
                width='full-width'
                style={{ width: '100%', marginLeft: 0 }}
                onClick={handlePopUpClose}
              >
                {skipButtonText}
              </Button>
            </div>
            <div className={`${styles.button} ${styles['right-button']}`}>
              <Button
                type='warn'
                width='full-width'
                onClick={handleConfirm}
                style={{ width: '100%', marginLeft: 0 }}
              >
                {confirmButtonText}
              </Button>
            </div>
          </div>
        )}
      </>
    );

    dispatch({
      type: ActionType.SET_POP_UP_CONTENT,
      payload: { PopUpContent: PopUpContent },
    });
    dispatch({ type: ActionType.SET_POP_UP_HEADER, payload: { popUpHeader } });
    dispatch({
      type: ActionType.SET_POP_UP_FOOTER,
      payload: { PopUpFooter: undefined },
    });
    dispatch({ type: ActionType.POP_UP_OPEN, payload: {} });
  }, [
    confirmButtonText,
    dispatch,
    handleConfirm,
    handlePopUpClose,
    hasFooter,
    popUpHeader,
    popUpText,
    skipButtonText,
  ]);

  return <MainButton onClick={handlePopUpOpen} type={closeButtonType} />;
};

export default ActionButton;
